import { Database, DatabaseItemsEntry, DatabaseManufacturer, DatabaseOwnerEntry, DatabaseProduct, DatabaseVariant, VariantItemEntry, DatabaseManufacturerPagination, DatabaseDppPagination, DatabaseProductPagination, DatabaseVariantPagination, DatabaseOrderVariants } from "./Database";
import { apiAction, apiInterface } from "./interface";


export default class API {
    iface: apiInterface

    constructor(iface: apiInterface) {
        this.iface = iface;
    }

    getOwners(): Promise<DatabaseOwnerEntry[]> {
        return this.iface.get(apiAction.GET_OWNERS)
    }

    getProducts(ownerId: string, type?:string , limit?:string, offset?:string): Promise<DatabaseProductPagination> {
        return this.iface.get(apiAction.GET_PRODUCTS, {owner_id: ownerId, type:(type ? type: ""), limit:(limit ? limit: "") ,offset:(offset ? offset: "")})
    }

    getParentProducts(ownerId: string, limit?: string, offset?:string): Promise<DatabaseProductPagination> {
        return this.getProducts(ownerId, "parent_list", limit, offset)
    }

    getProduct( productId: string): Promise<DatabaseProduct> {
        return this.iface.get(apiAction.GET_PRODUCT, { productId: productId})
    }

    getVariantList(productId: string, limit:string, offset:string): Promise<DatabaseVariantPagination> {
        return this.iface.get(apiAction.GET_VARIANTS, { productId: productId, limit:limit, offset:offset})
    }

    getOwner(ownerId: string): Promise<DatabaseOwnerEntry> {
        return this.iface.get(apiAction.GET_OWNER, {ownerId: ownerId})
    }

    getManufacturers(ownerId: string,limit:string, offset:string): Promise<DatabaseManufacturerPagination> {
        return this.iface.get(apiAction.GET_MANUFACTURERS, {ownerId: ownerId, limit:limit, offset:offset})
    }

    getManufacturer(ownerId: string, manufacturerId: string): Promise<DatabaseManufacturer> {
        return this.iface.get(apiAction.GET_MANUFACTURER, {ownerId: ownerId, manufacturerId: manufacturerId})
    }

    getDpps( ownerId:string, limit:string, offset:string): Promise<DatabaseDppPagination> {
        return this.iface.get(apiAction.GET_DPP,{ owner_id:ownerId, limit:limit, offset:offset})
    }

    getDpp( itemId:string, format?: string): Promise<DatabaseDppPagination> {
        return this.iface.get(apiAction.GET_ITEM,{ item_id:itemId, format:(format? format : "")})
    }

    getDppQRCode( itemId:string): Promise<Blob> {
        return this.iface.raw(apiAction.GET_ITEM,{ item_id:itemId, format:"qr_code"})
    }


    deleteProduct(ownerId: string, productId: string): Promise<boolean> {
        return this.iface.delete(apiAction.DELETE_PRODUCT, null, {ownerId: ownerId, productId: productId})
    }

    deleteManufacturer(ownerId: string, manufacturerId: string): Promise<boolean> {
        return this.iface.delete(apiAction.DELETE_MANUFACTURER, null, {ownerId: ownerId, manufacturerId: manufacturerId})
    }

    addProduct(ownerId: string, product: DatabaseProduct): Promise<string> {
        return this.iface.post(apiAction.REGISTER_PRODUCT, product, {ownerId: ownerId})
    }

    addManufacturer(ownerId: string, manufacturer: DatabaseManufacturer): Promise<string> {
        return this.iface.post(apiAction.REGISTER_MANUFACTURER, manufacturer, {ownerId: ownerId})
    }

    editProduct(ownerId: string, productId: string, product: DatabaseProduct): Promise<boolean> {
        return this.iface.put(apiAction.UPDATE_PRODUCT, product, {ownerId: ownerId, productId: productId})
    }

    editManufacturer(ownerId: string, manufacturerId: string, manufacturer: DatabaseManufacturer): Promise<boolean> {
        return this.iface.put(apiAction.UPDATE_MANUFACTURER, manufacturer, {ownerId: ownerId, manufacturerId: manufacturerId})
    }

    editOwner(ownerId: string, data: DatabaseOwnerEntry): Promise<boolean> {
        return this.iface.put(apiAction.UPDATE_OWNER, data, {ownerId: ownerId})
    }

    addItem(ownerId: string, data: DatabaseItemsEntry): Promise<boolean> {
        return this.iface.post(apiAction.REGISTER_ITEM, data, {ownerId: ownerId})
    }

    editVariantOrder(list: DatabaseOrderVariants): Promise<boolean> {
        return this.iface.post(apiAction.EDIT_ORDER_VARIANTS, list)
    }
}

